<template>
  <div>
    <el-card>
      <div>
        <el-table :data="tableData" border highlight-current-row size="small" max-height="800">
          <el-table-column prop="Id" :label="translateWords.Id" width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="ChangeTypeName" :label="translateWords.ChangeTypeName" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="QtyChangeBefore" :label="translateWords.QtyChangeBefore" width="150"></el-table-column>
          <el-table-column prop="QtyChangeAfter" :label="translateWords.QtyChangeAfter" width="150"></el-table-column>
          <el-table-column prop="OpUserName" :label="translateWords.OpUserName" show-overflow-tooltip></el-table-column>
          <el-table-column :formatter="dateFormat" prop="OpTime" :label="translateWords.OpTime" show-overflow-tooltip></el-table-column>
        </el-table>
        <el-pagination
          background
          style="margin:1em 0"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100, 200]"
          :current-page="currPage"
          :page-size="pageSize"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>
<script>
  import { importScript } from '../util/importScript';
  export default {
    name: 'SampleChangeLog',
    props: {
      rowModel: {
        //样品实体
        type: Object,
        required: true,
      },
    },

    data() {
      return {
        uid: this.$route.query.uid,
        token: this.$route.query.token,
        lang: this.$route.query.lang,
        total: 0,
        currPage: 1,
        pageSize: 10,
        isQuery: false,
        tableData: [],
        translateWords: {
          pageTitle: '库存变动记录',
          keyCode: '关键字',
          query: '查询',
          Id: '序号',
          OpUserId: '操作员工号',
          OpUserName: '操作员',
          OpTime: '操作时间',
          ChangeTypeName: '业务类型',
          QtyChangeAfter: '修改后数量',
          QtyChangeBefore: '修改前数量',
        },
        key: '',
      };
    },
    mounted() {
      var that = this;
      importScript(this.baseurl, () => {
        that.jsT = window.jsT;
        that.translateWord();
      });
    },
    created() {
      this.getData();
    },
    methods: {
      translateWord() {
        let that = this;
        if (this.jsT) {
          for (const key in that.translateWords) {
            this.translateWords[key] = window.jsT.T(that.translateWords[key]);
          }
          z;
        } else {
          console.log('翻译器没有加载成功');
        }
      },
      dateFormat: function(row, column) {
        var date = row[column.property];
        if (date === undefined) {
          return '';
        }
        var moment = require('moment');
        return moment(date).format('YYYY-MM-DD HH:mm:ss');
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.currPage = 1;
        this.getData();
      },
      handleCurrentChange(val) {
        this.currPage = val;
        this.getData();
      },
      getData(isFirstLoad = false) {
        if (isFirstLoad) {
          this.currPage = 1;
        }
        var params = new URLSearchParams();
        params.append('pageIndex', this.currPage);
        params.append('pageSize', this.pageSize);
        params.append('lang', this.lang);
        params.append('uid', this.uid);
        params.append('cmd', 'GetSampleChangeLogPageList');
        if (this.isQuery) {
          params.append('KeyCode', this.key);
        }
        params.append('Id', this.rowModel.Id);
        params.append('Guid', this.rowModel.Sys_Guid);
        this.$http.post(this.actionurl, params).then((res) => {
          this.tableData = res.data.Data.list;
          this.total = res.data.Data.total;
        });
      },
      query() {
        this.isQuery = true;
        this.getData(true);
      },
    },
  };
</script>
<style scoped>
  .my-page {
    text-align: initial !important;
  }

  .page-title {
    font-weight: bold;
    margin: 0px 0px 15px;
    font-size: 26px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SampleChangeLog.vue